var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus_svg__10---Design-System",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus_svg__Design-System---Assets",
    transform: "translate(-716 -1128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus_svg__Global-Icons-16x16",
    transform: "translate(715 1061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus_svg__Icon-/Small/Add",
    transform: "translate(0 66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus_svg__Icon-/Add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus_svg__Icon-/-Notification-/-Active-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "plus_svg__Path",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 2v5h5a1 1 0 010 2H9v5a1 1 0 01-2 0V9H2a1 1 0 110-2h5V2a1 1 0 112 0z",
    id: "plus_svg__Path",
    fill: "#3F6DB4"
  })))))))));
}
export default SvgPlus;